import React from 'react';
import ProductHeader from './sections/ProductHeader';
import SettingsPanel from './sections/SettingsPanel';
import PricingSummary from './sections/PricingSummary';
import ProductInvoicesSection from './sections/ProductInvoicesSection';
import MembersSection from './sections/MembersSection';

export default function MembershipProductShow() {
  return (
    <div className="membership-product-show container-fluid pt-3">
      <ProductHeader />

      <div className="row">
        <div className="col-lg-6 mb-3">
          <SettingsPanel />
        </div>
        <div className="col-lg-6 mb-3">
          <PricingSummary />
        </div>
      </div>

      <MembersSection />

      <ProductInvoicesSection />
    </div>
  );
}
